import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-2",
  "use": "play-2-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"play-2\">\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"16\" transform=\"translate(50 51)\">\n    <circle cx=\"200\" cy=\"200\" r=\"200\" />\n    <polygon fill=\"currentColor\" fill-rule=\"nonzero\" points=\"166.667 140 260 200 166.667 260\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol